import { Table, Paper, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { FC } from "react";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";

const layers = [5,10,15,20,25] //anos que são mostrados na tabela de retorno

export interface TabelaRetornoInvestimentoProps {
    dadosRetorno: any;
    rangePayback: any;
}

const TabelaRetornoInvestimento: FC<TabelaRetornoInvestimentoProps> = ({dadosRetorno, rangePayback}) => {
    return <>
        <div className="tituloTabelaRetorno">Tempo para retorno sobre o investimento (payback): {rangePayback}</div>
        <Table component={Paper} size="small" className="table table-retorno-investimento" style={{marginLeft: "14.5%", width: "71%"}}>
            <TableHead>
                <TableRow>
                    <TableCell className="tableColEquipamentoHead font-intelbras-bold bg-verde-intelbras text-white" style={{textAlign: "center"}}>Ano</TableCell>
                    <TableCell className="tableColEquipamentoHead font-intelbras-bold bg-verde-intelbras text-white" style={{textAlign: "center"}}>Geração anual (kWh)</TableCell>
                    <TableCell className="tableColEquipamentoHead font-intelbras-bold bg-verde-intelbras text-white" style={{textAlign: "center"}}>Economia <br />acumulada</TableCell>
                    <TableCell className="tableColEquipamentoHead font-intelbras-bold bg-verde-intelbras text-white" style={{textAlign: "center"}}>Retorno do <br />investimento</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                { dadosRetorno ? dadosRetorno?.map((dado: any, index: number) => {
                    return (
                        <>
                            {(dadosRetorno.length < 20 || layers.includes(dado.ano)) && (
                                <TableRow>
                                    <TableCell className={`${(index % 2 === 0) ? 'tableColEquipamento' : 'tableColEquipamentoOdd'}`} style={{textAlign: "center"}}>
                                        {dado.ano}
                                    </TableCell>
                                    <TableCell className={`${(index % 2 === 0) ? 'tableColEquipamento' : 'tableColEquipamentoOdd'}`} style={{textAlign: "center"}}>
                                        {DecimalUtil.decimal(dado.geracao_anual_energia_kwh)}
                                    </TableCell>
                                    <TableCell className={`${(index % 2 === 0) ? 'tableColEquipamento' : 'tableColEquipamentoOdd'}`} style={{textAlign: "center"}}>
                                        R$ {DecimalUtil.decimal(dado.economia_acumulada)}
                                    </TableCell>
                                    <TableCell className={`${(index % 2 === 0) ? 'tableColEquipamento' : 'tableColEquipamentoOdd'}`} style={{textAlign: "center"}}>
                                        {dado.retorno_investimento >= 0 ? "R$ " : "- R$ "} {dado.retorno_investimento < 0 ? DecimalUtil.decimal(dado.retorno_investimento * -1) : DecimalUtil.decimal(dado.retorno_investimento) || "0,00"}
                                    </TableCell>
                                </TableRow>
                            )}
                        </>
                    )
                }) : null}
            </TableBody>
        </Table>
    </>

}

export default TabelaRetornoInvestimento;